import React from 'react'

import { NavigationCardsProps } from './navigation-cards.d';

import NavigationCards from '/react4xp/components/NavigationCards';

function NavigationCardsPart(props: NavigationCardsProps) {
    return <NavigationCards {...props} />
}

export default (props) => <NavigationCardsPart {...props} />
